import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(dashboard)/home.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ui/calendar-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ui/visible-video.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/vercel/path0/node_modules/.pnpm/next-auth@5.0.0-beta.25_next@15.2.8_@babel+core@7.25.2_@opentelemetry+api@1.9.0_react-dom@19._qjk2lbo5y2lo7dyc67ezxiv6mq/node_modules/next-auth/react.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.2.8_@babel+core@7.25.2_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0/node_modules/next/dist/client/app-dir/link.js");
